(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', './ReactImageMagnify', './ReactImageMagnifyTouch'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./ReactImageMagnify'), require('./ReactImageMagnifyTouch'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.ReactImageMagnify, global.ReactImageMagnifyTouch);
        global.index = mod.exports;
    }
})(this, function (exports, _ReactImageMagnify, _ReactImageMagnifyTouch) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.ReactImageMagnifyTouch = exports.ReactImageMagnify = undefined;

    var _ReactImageMagnify2 = _interopRequireDefault(_ReactImageMagnify);

    var _ReactImageMagnifyTouch2 = _interopRequireDefault(_ReactImageMagnifyTouch);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.ReactImageMagnify = _ReactImageMagnify2.default;
    exports.ReactImageMagnifyTouch = _ReactImageMagnifyTouch2.default;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/index.js
 ** module id = 1106
 ** module chunks = 0
 **/